/**
 * Created by andrey on 08.08.2025
 */

cc.FadeTo = function (duration, opacity) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._toOpacity = 0;
    this._fromOpacity = 0;

    if (opacity !== undefined) {
        this.initWithDuration(duration, opacity);
    }
};

cc.FadeTo.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.FadeTo,

    initWithDuration: function (duration, opacity) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, duration)) {
            this._toOpacity = opacity;
            return true;
        }
        return false;
    },

    update: function (time) {
        time = this._computeEaseTime(time);
        const fromOpacity = this._fromOpacity !== undefined ? this._fromOpacity : 255;
        this.target.opacity = fromOpacity + (this._toOpacity - fromOpacity) * time;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        this._fromOpacity = target.opacity;
    }
});

cc.fadeTo = (duration, opacity) => new cc.FadeTo(duration, opacity);

cc.FadeIn = function (duration = 0) {
    cc.FadeTo.prototype.constructor.call(this);

    this.initWithDuration(duration, 255);
};

cc.FadeIn.prototype = Object.assign(Object.create(cc.FadeTo.prototype), {
    constructor: cc.FadeIn
});

cc.fadeIn = (duration) => new cc.FadeIn(duration);

cc.FadeOut = function (duration = 0) {
    cc.FadeTo.prototype.constructor.call(this);

    this.initWithDuration(duration, 0);
};

cc.FadeOut.prototype = Object.assign(Object.create(cc.FadeTo.prototype), {
    constructor: cc.FadeOut
});

cc.fadeOut = (duration) => new cc.FadeOut(duration);
